/*
    Add here your own custom javascript
*/

// Fix for the RTL language in the demo
document.querySelectorAll('[href="/ar"]').forEach(link => {
    link.setAttribute('target', '_blank')
})

// EcomGraduates - Affiliate tracking code
function addRefParamToUrlsAndSetCookie () {
    const urlParams = new URLSearchParams(window.location.search)
    let refParam = urlParams.get('ref')

    if (!refParam) {
        // Check if the "ref" cookie exists
        const cookies = document.cookie.split(';')
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim()
            if (cookie.startsWith('ref=')) {
                refParam = cookie.substring(4)

                urlParams.set('ref', refParam)
                break
            }
        }
    }

    if (refParam) {
    // Set the "ref" cookie with the "ref" parameter value
        document.cookie = `ref=${refParam}; expires=${new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)}; path=/`

        // Update the URLs on the page with the "ref" parameter value
        const links = document.getElementsByTagName('a')
        for (let i = 0; i < links.length; i++) {
            const link = links[i]
            const url = new URL(link.href)
            if (url.hostname === 'ecomgraduates.com') {
                if (url.search) {
                    url.search += `&ref=${refParam}`
                } else {
                    url.search = `?ref=${refParam}`
                }
                link.href = url.href
            }
        }
    }
}
// addRefParamToUrlsAndSetCookie()

window.quickviewPoup = async function (element, event) {
    event.preventDefault();

    let handle = element.dataset.handle
    if (!handle) return console.error("No data-handle found on element")

    try {
        let url = `/products/${handle}?section_id=quick-view`
        let res = await fetch(url)
        if (!res.ok) throw new Error(`HTTP ${res.status}`)

        let html = await res.text()      
        let parser = new DOMParser()
        let doc = parser.parseFromString(html, 'text/html')
        let sectionHTML = doc.querySelector('[id^="shopify-section-quick-view"]')
        if (!sectionHTML) throw new Error("Quick view section not found")
        let modalBody = document.getElementById('quickview-modal-content')
        if (modalBody) modalBody.innerHTML = sectionHTML.innerHTML
        bootstrap.Modal.getOrCreateInstance('#quickviewModal').show()

    } catch (err) {
        console.error("Error loading quick view:", err)
    }
}


window.BundlequickviewPoup = async function (element, event) {
    event.preventDefault();

    let handle = element.dataset.handle
    if (!handle) return console.error("No data-handle found on element")

    try {
        let url = `/products/${handle}?section_id=bundle-quick-view`
        let res = await fetch(url)
        if (!res.ok) throw new Error(`HTTP ${res.status}`)

        let html = await res.text()      
        let parser = new DOMParser()
        let doc = parser.parseFromString(html, 'text/html')
        let sectionHTML = doc.querySelector('[id^="shopify-section-bundle-quick-view"]')
        if (!sectionHTML) throw new Error("Quick view section not found")
        let modalBody = document.getElementById('quickview-modal-content')
        if (modalBody) modalBody.innerHTML = sectionHTML.innerHTML
        bootstrap.Modal.getOrCreateInstance('#quickviewModal').show()

    } catch (err) {
        console.error("Error loading quick view:", err)
    }
}




document.addEventListener("DOMContentLoaded", function () {
  // --- Desktop Navbar hover ---
  const desktopLinks = document.querySelectorAll(".navbar");
  const desktopNavbar = document.querySelector(".index-navbar-desktop");

  if (desktopLinks.length > 0 && desktopNavbar) {
    desktopLinks.forEach(link => {
      link.addEventListener("mouseenter", () => {
        if (window.scrollY === 0) {
          desktopNavbar.classList.replace("text-white", "text-body");
        }
      });

      link.addEventListener("mouseleave", () => {
        if (window.scrollY === 0) {
          desktopNavbar.classList.replace("text-body", "text-white");
        }
      });
    });
  }

  // --- Mobile Navbar toggle ---
  const mobileLinks = document.querySelectorAll(".menu-toggle");
  const mobileNavbar = document.querySelector(".index-navbar-mobile");

  if (mobileLinks.length > 0 && mobileNavbar) {
    mobileLinks.forEach(link => {
      link.addEventListener("click", () => {
        if (window.scrollY === 0) {
          if (mobileNavbar.classList.contains("text-white")) {
            mobileNavbar.classList.replace("text-white", "text-body");
          } else {
            mobileNavbar.classList.replace("text-body", "text-white");
          }
        }
      });
    });
  }

  // --- Menu form toggle ---
  document.addEventListener("click", function (e) {
    const heading = e.target.closest(".menu-reg-form-row > h4");
    if (!heading) return;

    const detail = heading.nextElementSibling;
    const form = heading.closest(".menu-reg-form");

    if (!form || !detail || !detail.classList.contains("menu-reg-form-detail")) return;

    // Close all others in the same form
    form.querySelectorAll(".menu-reg-form-detail").forEach((el) => {
      if (el !== detail) el.classList.remove("active");
    });

    detail.classList.toggle("active");
  });

  // --- Masonry popup ---
  const gridItems = document.querySelectorAll(".masonry-grid-on-hover");
  if (gridItems.length > 0) {
    gridItems.forEach((item) => {
      const parentLi = item.closest("li");
      const popup = parentLi ? parentLi.querySelector(".popup-product") : null;
      const closeBtn = popup ? popup.querySelector(".close-popup") : null;

      if (popup && closeBtn) {
        item.addEventListener("click", function (e) {
          e.stopPropagation();
          popup.classList.add("active");
        });

        closeBtn.addEventListener("click", function (e) {
          e.stopPropagation();
          popup.classList.remove("active");
        });

        document.addEventListener("click", function (e) {
          if (!popup.contains(e.target) && !item.contains(e.target)) {
            popup.classList.remove("active");
          }
        });
      }
    });
  }

  // --- Cards with image (mobile only) ---
  if (window.innerWidth < 767) {
    const cardLinks = document.querySelectorAll('.cards-with-image .col .card-link-wrapper');
    if (cardLinks.length > 0) {
      cardLinks.forEach(link => {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          const href = this.getAttribute('href');

          const menuToggle = document.querySelector('.nav-link.menu-toggle');
          if (menuToggle) menuToggle.click();

          setTimeout(() => {
            const shopByCarLink = document.querySelector('.nav-link.shop-by-car');
            if (shopByCarLink) shopByCarLink.click();

            const skipStep = document.querySelector('.skip-step');
            if (skipStep) {
              skipStep.style.display = 'block';
              const skipAnchor = skipStep.querySelector('a');
              if (skipAnchor) skipAnchor.setAttribute('href', href);
            }
          }, 300);
        });
      });
    }

    const menuToggleBtn = document.querySelector('.nav-link.menu-toggle');
    if (menuToggleBtn) {
      menuToggleBtn.addEventListener('click', () => {
        const skipStep = document.querySelector('.skip-step');
        if (skipStep) {
          setTimeout(() => {
            if (!document.activeElement.closest('.card-link-wrapper')) {
              skipStep.style.display = 'none';
            }
          }, 100);
        }

        const shopByCarCollapse = document.querySelector('.shop-by-car.collapse');
        if (shopByCarCollapse?.classList.contains('show')) {
          shopByCarCollapse.classList.remove('show');
        }
      });
    }
  }

 // --- Checkbox sync between top filters & sidebar ---

document.addEventListener('change', function(event) {
 
  if (event.target.matches('.collection-top-product-type-filters input[name="filter.p.product_type"]')) {
    let value = event.target.value;
    let sidebarCheckbox = document.querySelector('.collection-filters-form input[name="filter.p.product_type"][value="' + value + '"]');
    
    if (sidebarCheckbox) {
      sidebarCheckbox.checked = event.target.checked;
      onChangeCollectionFilter(sidebarCheckbox, new Event('change'));
    }
  }
  

  else if (event.target.matches('.collection-filters-form input[name="filter.p.product_type"]')) {
    let value = event.target.value;
    let topCheckbox = document.querySelector('.collection-top-product-type-filters input[name="filter.p.product_type"][value="' + value + '"]');
    
    if (topCheckbox) {
      topCheckbox.checked = event.target.checked;
    }
  }
});
});


document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", function (e) {
    if (e.target.closest(".btn-filters-desktop")) {
      const filterBlock = document.querySelector(".desktop-filter-block"); // fresh lookup
      const productBlock = document.querySelector(".collection-products-block");

      if (!filterBlock || !productBlock) return; // safety check

      filterBlock.classList.toggle("active");

      if (filterBlock.classList.contains("active")) {
        productBlock.classList.remove("col-md-12");
        productBlock.classList.add("col-md-9", "col-lg-10");
      } else {
        productBlock.classList.remove("col-md-9", "col-lg-10");
        productBlock.classList.add("col-md-12");
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const cardLinks = document.querySelectorAll(".cards-with-image .col .card-link-wrapper");
 if (cardLinks.length > 0 ) {
  cardLinks.forEach(link => {
    link.addEventListener("click", function () {
      sessionStorage.setItem("from_home_cards", "yes");
    });
  });
}
});

document.addEventListener("DOMContentLoaded", function () {
  const banner = document.querySelector(".collection-header-banner");
if(banner){
  if (sessionStorage.getItem("from_home_cards") === "yes") {
    banner.classList.remove("no-came-to-home"); // keep showing, even after refresh
  } else {
    banner.classList.add("no-came-to-home");
  }
}
});

window.addEventListener('DOMContentLoaded', function () {
  const inStockFilter = document.querySelector('.collection-filters-form input.in-stock');
  if (inStockFilter) {
    inStockFilter.checked = true; // Optional: check it if not already
    inStockFilter.dispatchEvent(new Event('change', { bubbles: true }));
  }
});

document.addEventListener("DOMContentLoaded", function () {
  let carouselInitialized = false;

  function initializeCarousel() {
    if (carouselInitialized) return; // Prevent multiple initializations
    
    setTimeout(() => {
      const carousel = document.querySelector(".collection-top-product-type-filters");
      const slide = document.querySelector(".form-check");
      const nextBtn = document.getElementById("nextBtn");
      const prevBtn = document.getElementById("prevBtn");

      if (!carousel || !slide || !nextBtn || !prevBtn) {
        console.warn("Carousel elements not found");
        carouselInitialized = false;
        return;
      }

      function updateButtonVisibility() {
        const canScrollLeft = carousel.scrollLeft > 0;
        const canScrollRight = carousel.scrollLeft < (carousel.scrollWidth - carousel.clientWidth);
        const hasOverflow = carousel.scrollWidth > carousel.clientWidth;
        
        // Show/hide buttons based on overflow and scroll position
        if (!hasOverflow) {
          // No overflow, hide both buttons
          nextBtn.style.display = 'none';
          prevBtn.style.display = 'none';
        } else {
          // Has overflow, show buttons based on scroll position
          prevBtn.style.display = canScrollLeft ? 'block' : 'none';
          nextBtn.style.display = canScrollRight ? 'block' : 'none';
        }
      }

      function handleCarouselMove(positive = true) {
        const slideWidth = slide.clientWidth;
        carousel.scrollLeft = positive
          ? carousel.scrollLeft + slideWidth
          : carousel.scrollLeft - slideWidth;
        
        // Update button visibility after scroll
        setTimeout(updateButtonVisibility, 100);
      }

      // Remove existing listeners to prevent duplicates
      nextBtn.removeEventListener("click", nextBtnHandler);
      prevBtn.removeEventListener("click", prevBtnHandler);

      // Define handlers
      function nextBtnHandler() { handleCarouselMove(true); }
      function prevBtnHandler() { handleCarouselMove(false); }

      // Add event listeners
      nextBtn.addEventListener("click", nextBtnHandler);
      prevBtn.addEventListener("click", prevBtnHandler);

      // Listen for scroll events to update button visibility
      carousel.addEventListener('scroll', updateButtonVisibility);

      // Listen for window resize to recalculate
      window.addEventListener('resize', () => {
        setTimeout(updateButtonVisibility, 100);
      });

      // Initial button visibility check
      setTimeout(updateButtonVisibility, 100);

      carouselInitialized = true;
      console.log("Carousel initialized successfully");
    }, 2500);
  }

  // Initialize on page load
  initializeCarousel();

  // Set up MutationObserver to watch for DOM changes
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        // Check if carousel elements were added/modified
        const hasCarouselElements = Array.from(mutation.addedNodes).some(node => {
          return node.nodeType === Node.ELEMENT_NODE && 
                 (node.querySelector && (
                   node.querySelector(".collection-top-product-type-filters") ||
                   node.querySelector("#nextBtn") ||
                   node.querySelector("#prevBtn")
                 ));
        });
        
        if (hasCarouselElements) {
          carouselInitialized = false;
          setTimeout(initializeCarousel, 1000);
        }
      }
    });
  });

  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const dropdownMenus = document.querySelectorAll(".dropdown-megamenu");

  if (dropdownMenus.length > 0) {   
    dropdownMenus.forEach(menu => {
      menu.addEventListener("click", function (e) {
        if (!e.target.classList.contains('reg-go-btn')) {
          e.stopPropagation(); 
        }
      });

      menu.querySelectorAll("select").forEach(select => {
        select.addEventListener("mousedown", function (e) {
          e.stopPropagation();
        });
        select.addEventListener("click", function (e) {
          e.stopPropagation();
        });
      });
    });
  }
});


document.addEventListener("DOMContentLoaded", function () {
  const sliders = document.querySelectorAll('.splide-new');
  
  if (sliders.length > 0) {  
    sliders.forEach(function (el) {
      new Splide(el, {
        type       : 'slide',
        perPage    : 1,    
        perMove    : 1,
        gap        : '1rem',
        arrows     : true,
        pagination : false,
        rewind     : true,
        speed      : 400,
        easing     : 'cubic-bezier(.42,.65,.27,.99)',
      }).mount();
    });
  }
});



